import { AverageGoodsReportCompareComponent } from './average-goods-report-compare/average-goods-report-compare.component';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { ReportReviewModule } from "src/app/review/review.module";
import { AverageGoodsReportComponent } from "./average-goods-report/average-goods-report.component";
import { CirculationOfGoodsReportComponent } from "./circulation-of-goods-report/circulation-of-goods-report.component";
import { CostPriceOfManufacturedProductsReportComponent } from "./cost-price-of-manufactured-products-report/cost-price-of-manufactured-products-report.component";
import { FinishedPriceOfProductsBeforeSaleReportComponent } from "./finished-price-of-products-before-sale-report/finished-price-of-products-before-sale-report.component";
import { GeneralMonthlyFoodCostReportComponent } from "./general-monthly-food-cost-report/general-monthly-food-cost-report.component";
import { MaterialUseInProductReportComponent } from "./material-use-in-product-report/material-use-in-product-report.component";
import { NegativeRemainOfGoodsDalyReportComponent } from "./negative-remain-of-goods-daly-report/negative-remain-of-goods-daly-report.component";
import { NewDailyPurchaseInvoiceReportComponent } from "./new-daily-purchase-invoice-Report/new-daily-purchase-invoice-Report.component";
import { PriceChangeInPurchaseReportComponent } from "./price-change-in-purchase-report/price-change-in-purchase-report.component";
import { PurchaseInvoiceReportComponent } from "./purchase-invoice-report/purchase-invoice-report.component";
import { PurchaseReportWithTaxComponent } from "./purchase-report-with-tax/purchase-report-with-tax.component";
const components = [
  MaterialUseInProductReportComponent,
  PurchaseInvoiceReportComponent,
  PriceChangeInPurchaseReportComponent,
  FinishedPriceOfProductsBeforeSaleReportComponent,
  CirculationOfGoodsReportComponent,
  CostPriceOfManufacturedProductsReportComponent,
  GeneralMonthlyFoodCostReportComponent,
  NewDailyPurchaseInvoiceReportComponent,
  PurchaseReportWithTaxComponent,
  NegativeRemainOfGoodsDalyReportComponent,
  AverageGoodsReportComponent,
  AverageGoodsReportCompareComponent
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule, ReportReviewModule],
})
export class InventoryReportModule {}
